import { Button, styled } from "@mui/material";
import { Link } from "react-router-dom";

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px 48px',
    margin: '0px 0',
    background: theme.palette.mode === "light" ?
        theme.palette.background.lightSecondary : theme.palette.background.darkSecondary,
    borderRadius: theme.palette.bigBorderRadios,
    [theme.breakpoints.down('md')]: {
        padding: '12px  24px',
        // margin: '24px',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '6px 12px',
        // margin: '12px',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px',
        // margin: '0px',

    },
    transition: "0.3s all fade"
}))

export const HeadSection = styled('h3')(({ theme }) => (props) => ({
    fontSize: '1.8vw',
    fontWeight: 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    display: 'inline',
    margin: '0 10px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
    }
}))

export const HeadDepartment = styled('h3')(({ theme }) => (props) => ({
    fontSize: '1.6vw',
    fontWeight: 700,
    lineHeight: '8px',
    letterSpacing: '0em',
    display: 'inline',
    margin: '0',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.8vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
    }
}))

export const DepartmentDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: '1.3vw',
    fontWeight: 400,
    letterSpacing: '0em',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.5vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.7vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
    }
}))

export const DepartmentsDetails = styled('p')(({ theme }) => (props) => ({
    fontSize: '1.2vw',
    fontWeight: 400,
    letterSpacing: '0em',
    margin: 0,
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.5vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.7vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
    }
}))

export const DepartmentsSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 6px',
    position: 'relative',
    // '&:before': {
    //     position: "absolute",
    //     top: '40%',
    //     left: "-16px",
    //     content: props.text,
    //     transform: 'rotate(-90deg)',
    //     fontSize: "16px",
    //     fontWeight: 400,
    //     [theme.breakpoints.down('sm')]: {
    //         fontSize: '12px',
    //         left: "-18px",
    //     }
    // },
    [theme.breakpoints.down('sm')]: {
        padding: '8px 24px',
    }
}))

export const PartSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    padding: '24px 16px',
    flexDirection: 'column',
    borderLeft: 'solid 1px #BDBDBD',
    [theme.breakpoints.down('md')]: {
        padding: '12px 8px',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '6px',
    },
}))

export const DetailsPart = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',

}))

export const ShowItem = styled(Button)(({ theme }) => (props) => ({
    display: 'flex',
    padding: '16px 24px',
    fonSize: "14px",
    fontWeight: 400,
    color: theme.palette.primary.main,
    textDecoration: 'none',
    zIndex: '3',
    [theme.breakpoints.down('sm')]: {
        fonSize: "10px",
        padding: '8px 12px',
    }
}))






